<template>
  <div class="last-news">
    <div class="last-news__header">
      <h2 class="last-news__title">Останні новини</h2>
      <Divider type="horizontal" />
    </div>
    <div class="last-news__list">
      <NewsListSkeleton :is-loading="!isNewsDataReady">
        <NewsList :items="getNewsList" />
      </NewsListSkeleton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewsList from '../news-list';
import NewsListSkeleton from '../news-list-skeleton';
import { Divider } from '@/shared/ui/divider';

export default {
  created() {
    this.fetchLastNews();
  },
  components: { NewsList, Divider, NewsListSkeleton },
  computed: {
    ...mapGetters('lastNewsModule', ['isNewsDataReady', 'getNewsList']),
  },
  methods: {
    ...mapActions('lastNewsModule', ['fetchLastNews']),
  },
};
</script>

<style lang="scss" scoped>
.last-news {
  &__title {
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
